// MOCK: ApplyBookingResponseDto
// Activado cuando environment.useMocksInstructivoEmbarque = true
import { ApplyBookingResponseDto } from '@opb-workspace/shared';

export const MOCK_APPLY_BOOKING_FCL: ApplyBookingResponseDto = {
    bookingId: 4588221,
    bookingNumber: 'OPB-2024-001221',
    isOpbBooking: true,
    hasActiveShippingInstruction: false,
    customerId: 77,
    customerName: 'Frutexpo SpA',
    customerReference: 'FRX-EXP-2024-447',
    terminalPol: 'Terminal Puerto Coronel',
    etd: '2024-11-04',
    cutOffDocumental: '2024-11-01',
    billOfLadingIssuer: 'MSC',
    countryOfFinalDestination: 'Países Bajos',
    remarks: 'Carga refrigerada — mantener a -1°C durante tránsito.',
    shipper: {
        partyId: 201,
        name: 'Frutexpo SpA',
        address: 'Av. del Mar 1234, Coronel, Chile',
    },
    consignee: {
        partyId: 305,
        name: 'Rotterdam Fresh Imports B.V.',
        address: 'Maasvlakte 2, 3199 LS Rotterdam, Netherlands',
    },
    notify: undefined,
    items: [
        {
            containerNumber: 'MSCU3456789',
            containerType: '40RF',
            cargoType: 'FCL',
            packages: [
                {
                    commodityDescription: 'Uvas de Mesa — Red Globe',
                    hsCode: '0806.10',
                    packageType: 'Caja',
                    packageQuantity: 1200,
                    grossWeightKg: 19200,
                    volumeM3: 38.4,
                },
            ],
        },
        {
            containerNumber: 'MSCU7891234',
            containerType: '40RF',
            cargoType: 'FCL',
            packages: [
                {
                    commodityDescription: 'Manzanas — Fuji Export',
                    hsCode: '0808.10',
                    packageType: 'Bin',
                    packageQuantity: 48,
                    grossWeightKg: 21600,
                    volumeM3: 43.2,
                },
            ],
        },
    ],
    preloadedFields: [
        'customerName',
        'customerReference',
        'terminalPol',
        'etd',
        'cutOffDocumental',
        'billOfLadingIssuer',
        'countryOfFinalDestination',
        'remarks',
        'shipperName',
        'shipperAddress',
        'consigneeName',
        'consigneeAddress',
        'items',
    ],
};

export const MOCK_APPLY_BOOKING_LCL: ApplyBookingResponseDto = {
    isOpbBooking: true,
    hasActiveShippingInstruction: false,
    bookingId: 4588305,
    bookingNumber: 'OPB-2024-001305',
    customerId: 82,
    customerName: 'Exportaciones Del Sur Ltda.',
    customerReference: undefined,
    terminalPol: undefined,
    etd: '2024-11-04',
    cutOffDocumental: undefined,
    billOfLadingIssuer: undefined,
    countryOfFinalDestination: undefined,
    remarks: undefined,
    shipper: {
        partyId: 210,
        name: 'Exportaciones Del Sur Ltda.',
        address: 'Lota 456, Lota, Chile',
    },
    consignee: undefined,
    notify: undefined,
    items: [
        {
            containerNumber: undefined,
            containerType: undefined,
            cargoType: 'LCL',
            packages: [
                {
                    commodityDescription: 'Kiwis — Hayward Export',
                    hsCode: '0810.50',
                    packageType: 'Caja',
                    packageQuantity: 600,
                    grossWeightKg: 7800,
                    volumeM3: 15.6,
                },
            ],
        },
    ],
    preloadedFields: [
        'customerName',
        'etd',
        'shipperName',
        'shipperAddress',
        'items',
    ],
};
